import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Tooltip,
    Typography,
    DialogContentText,
    Switch,
} from "@mui/material";

import { Add, Edit, Delete } from "@mui/icons-material";
import apiClient from "../utils/apiClient";
import { toast } from "react-toastify";

// ✅ Replace with your backend URL

const CouponsPage = () => {
    const [coupons, setCoupons] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");

    const [openDialog, setOpenDialog] = useState(false);
    const [editingCoupon, setEditingCoupon] = useState(null);

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const [form, setForm] = useState({
        code: "",
        discountType: "percentage",
        discountValue: "",
        minOrderAmount: "",
        usageLimit: "",
        validFrom: "",
        validTo: "",
    });

    // 🔹 Fetch Coupons
    const fetchCoupons = async () => {
        try {
            const res = await apiClient.get("/api/coupon/all", {
                params: { page: page + 1, limit, search },
            });
            setCoupons(res.data.data.coupons);
            setTotal(res.data.data.pagination.total);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchCoupons();
    }, [page, limit, search]);

    // 🔹 Handle Form Change
    const handleChange = (e) => {
        if(e.target.name === 'code'){
            setForm({ ...form, [e.target.name]: e.target.value.toUpperCase() });
        }else{
            setForm({ ...form, [e.target.name]: e.target.value });
        }
    };

    // 🔹 Open Dialog for Add / Edit
    const handleOpenDialog = (coupon = null) => {
        setEditingCoupon(coupon);
        if (coupon) {
            setForm({ ...coupon });
        } else {
            setForm({
                code: "",
                discountType: "percentage",
                discountValue: "",
                minOrderAmount: "",
                usageLimit: "",
                validFrom: "",
                validTo: "",
            });
        }
        setOpenDialog(true);
    };

    // 🔹 Save Coupon
    const handleSave = async () => {
        try {
            if (editingCoupon) {
                const res = await apiClient.put(`/api/coupon/update/${editingCoupon.id}`, form);
                toast.success(res?.data?.message);
            } else {
                const res = await apiClient.post('/api/coupon/create', form);
                toast.success(res?.data?.message);
            }
            setOpenDialog(false);
            fetchCoupons();
        } catch (err) {
            if (err.response) {
                toast.error(err.response.data.message || "Somthing Wrong");
            } else {
                toast.error("Network error. Please try again.");
            }
        }
    };

    // 🔹 Confirm Delete
    const handleDelete = async () => {
        try {
            await apiClient.delete(`/api/coupon/delete/${deleteId}`);
            setOpenDeleteDialog(false);
            fetchCoupons();
        } catch (error) {
            console.error(error);
        }
    };

    const handleStatusChange = async (id, newStatus) => {
        try {
            const res = await apiClient.put(`/api/coupon/update/${id}`, { isActive: newStatus });
            toast.success(res?.data?.message);
            fetchCoupons();
        }catch  (err) {
            if (err.response) {
                toast.error(err.response.data.message || "Somthing Wrong");
            } else {
                toast.error("Network error. Please try again.");
            }
        }
    };

    return (
        <Paper sx={{ px: 3, py: 3 }}>
            <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="h5" fontWeight="bold">
                    Coupon Management
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={() => handleOpenDialog()}
                >
                    Add New Coupon
                </Button>
            </Box>

            {/* Search */}
            <TextField
                label="Search Coupon"
                variant="outlined"
                size="small"
                fullWidth
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ mb: 2 }}
            />

            {/* Table */}
            <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableCell>Code</TableCell>
                            <TableCell>Discount</TableCell>
                            <TableCell>Min Order</TableCell>
                            {/* <TableCell>Usage</TableCell>
                            <TableCell>Validity</TableCell> */}
                            <TableCell>Status</TableCell>
                            <TableCell align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {coupons.map((coupon) => (
                            <TableRow key={coupon.id} hover>
                                <TableCell>{coupon.code}</TableCell>
                                <TableCell>
                                    {coupon.discountType === "percentage"
                                        ? `${coupon.discountValue}%`
                                        : `₹${coupon.discountValue}`}
                                </TableCell>
                                <TableCell>{coupon.minOrderAmount || "-"}</TableCell>
                                {/* <TableCell>
                                    {coupon.usedCount}/{coupon.usageLimit || "∞"}
                                </TableCell> */}
                                {/* <TableCell>
                                    {new Date(coupon.validFrom).toLocaleDateString()} -{" "}
                                    {new Date(coupon.validTo).toLocaleDateString()}
                                </TableCell> */}
                                <TableCell>
                                    <Switch
                                        checked={coupon.isActive}
                                        onChange={(e) =>
                                            handleStatusChange(
                                                coupon.id,
                                                e.target.checked
                                            )
                                        }
                                    />
                                    {/* {coupon.isActive ? "✅ Active" : "❌ Inactive"} */}
                                </TableCell>
                                <TableCell align="right">
                                    <Tooltip title="Edit">
                                        <IconButton
                                            color="primary"
                                            onClick={() => handleOpenDialog(coupon)}
                                        >
                                            <Edit />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete">
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                setDeleteId(coupon.id);
                                                setOpenDeleteDialog(true);
                                            }}
                                        >
                                            <Delete />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                        {coupons.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    No coupons found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={total}
                    page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    rowsPerPage={limit}
                    onRowsPerPageChange={(e) => {
                        setLimit(parseInt(e.target.value, 10));
                        setPage(0);
                    }}
                />
            </TableContainer>

            {/* Add/Edit Dialog */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle>{editingCoupon ? "Edit Coupon" : "Add Coupon"}</DialogTitle>
                <DialogContent dividers>
                    <TextField
                        label="Code"
                        name="code"
                        fullWidth
                        margin="normal"
                        value={form.code}
                        onChange={handleChange}
                    />
                    <TextField
                        select
                        SelectProps={{ native: true }}
                        label="Discount Type"
                        name="discountType"
                        fullWidth
                        margin="normal"
                        value={form.discountType}
                        onChange={handleChange}
                    >
                        <option value="percentage">Percentage</option>
                        <option value="fixed">Fixed</option>
                    </TextField>
                    <TextField
                        label="Discount Value"
                        name="discountValue"
                        type="number"
                        fullWidth
                        inputProps={{
                            min: 0,
                        }}
                        margin="normal"
                        value={form.discountValue}
                        onChange={handleChange}
                    />
                    <TextField
                        label="Min Order Amount"
                        name="minOrderAmount"
                        type="number"
                        fullWidth
                        inputProps={{
                            min: 0,
                        }}
                        margin="normal"
                        value={form.minOrderAmount}
                        onChange={handleChange}
                    />
                    {/* <TextField
            label="Usage Limit"
            name="usageLimit"
            type="number"
            fullWidth
            margin="normal"
            value={form.usageLimit}
            onChange={handleChange}
          />
          <TextField
            label="Valid From"
            name="validFrom"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={form.validFrom?.slice(0, 10) || ""}
            onChange={handleChange}
          />
          <TextField
            label="Valid To"
            name="validTo"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={form.validTo?.slice(0, 10) || ""}
            onChange={handleChange}
          /> */}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button onClick={handleSave} variant="contained">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation */}
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent dividers>
                    <DialogContentText>
                        Are you sure you want to delete this coupon?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
                    <Button onClick={handleDelete} color="error" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    );
};

export default CouponsPage;
